<script setup>
defineProps({ modelValue: [String, Number] })
const emit = defineEmits(["update:modelValue"])
</script>

<template>
  <select
    class="select"
    :value="modelValue"
    @change="emit('update:modelValue', $event.target.value)"
  >
    <slot />
  </select>
</template>

<style scoped>
.select {
  @apply flex h-11 w-full rounded-md border bg-transparent px-4 text-sm
    text-foreground
    focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0
    focus-visible:border-primary/40
    disabled:cursor-not-allowed disabled:opacity-50;

  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' stroke='%23a1a1aa' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
  background-color: hsl(var(--card));
  color: hsl(var(--foreground));
}

.select:hover {
  background-color: hsl(var(--card) / 0.85);
}

.select option {
  background-color: hsl(var(--card)); 
  color: hsl(var(--foreground));      
}

.select option:checked,
.select option:hover {
  background-color: hsl(var(--muted));
  color: hsl(var(--foreground));
}
</style>
